/*
 * liftoffEvent.js — compact, body-free summary of ONE Liftoff (Vungle) SDK
 * telemetry post (POST logs.ads.vungle.com/vm/logs). Stored at capture time as
 * validData.sdkEvent so the lifecycle assembler can still use it after the
 * request body is stripped from history (validData survives; bodies do not).
 *
 * Consumer: lifecycle/buildSlotLifecycles.js 'sdkTelemetry' impression tier —
 * the Liftoff SDK's `impression` event stands in for the Google/Liftoff
 * impression pings when those never reach the proxy (QUIC).
 *
 * extractLiftoffEvent(rowLike) → { network:'liftoff', name, placementType,
 * width, height, isMuted, creativeId, advertiserDomain, placementRef } (only
 * the fields present) or null. One event per post is the norm; for an array /
 * {events:[…]} body the first named event wins. Never throws. Logcat rows carry
 * no body, so they return null.
 *
 * Server twin: proxy-server/adQuality/liftoffEvent.js — keep identical
 * (proxy-server/test/liftoffEventParity.test.js). Used when a saved HAR is opened.
 */

import { bodyText, eventsOf } from './soundOnAutoplay.js';

const num = (v) => {
    const n = typeof v === 'string' && v.trim() ? Number(v) : v;
    return typeof n === 'number' && isFinite(n) && n > 0 ? n : undefined;
};
const str = (v) => (typeof v === 'string' && v.trim() ? v.trim() : undefined);

export function extractLiftoffEvent(rowLike) {
    try {
        const row = rowLike || {};
        let u;
        try { u = new URL(String(row.url || '')); } catch { return null; }
        const host = u.hostname.toLowerCase();
        if (!(host === 'vungle.com' || host.endsWith('.vungle.com'))) return null;
        if (!/^\/vm\/logs\/?$/.test(u.pathname)) return null;

        let body = bodyText(row);
        if (body == null) return null;
        if (typeof body === 'string') {
            try { body = JSON.parse(body); } catch { return null; }
        }
        const ev = eventsOf(body).find((e) => e && typeof e === 'object' && str(e.name));
        if (!ev) return null;

        const out = { network: 'liftoff', name: str(ev.name) };
        const set = (k, v) => { if (v !== undefined) out[k] = v; };
        set('placementType', str(ev.placement_type));
        set('width', num(ev.width));
        set('height', num(ev.height));
        if (ev.is_muted === true || ev.is_muted === 'true') out.isMuted = true;
        else if (ev.is_muted === false || ev.is_muted === 'false') out.isMuted = false;
        set('creativeId', str(ev.creative_id));
        set('advertiserDomain', str(ev.advertiser_domain));
        set('placementRef', str(ev.placement_reference_id));
        return out;
    } catch (e) {
        return null;
    }
}
